<template>
  <div class="projectListItem">
    <img class="projectListImg" :src="projectListItem.imgSrc" alt=""width="100%">
    <div class="projectListWord">
      <div class="projectListTitle">{{projectListItem.title}}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "projectListItem",
  props:{
    projectListItem:{
      type:Object,
      default(){
        return[]
      }
    }
  },
}
</script>

<style scoped>
.projectListItem{
  margin:25px;
}
.projectListImg{
  width: 100%;
  height: 260px;
}
.projectListWord{
  width: 380px;
  height: 80px;
  background: #ffffff;
  box-shadow: 0px 3px 15px 0px rgba(0, 0, 0, 0.33);
  display: flex;
  justify-content: center;
  justify-content: space-around;
  align-items: center;
  border-top: none;
}
.projectListTitle{
  width: 370px;
  height: 20px;
  font-size: 18px;
  font-family: SourceHanSansCN;
  font-weight: 540;
  color: #000000;
  line-height: 22px;
  margin: 0 auto;
}
.projectListItem:hover{
  transform:scale(1.2, 1.2);
}
</style>